import EFmhAcIcon3 from '@/components/UI/svg/Icons/EFmhAcIcon3';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { TimelineMax, TweenMax } from 'gsap';
import css from './index.module.scss';
const { EFPic } = createEFPic('/media/mh200/h5/');

export default function MhFh5({}: any) {
    const { useLang, useEffect } = useGlobal();
    const { t } = useLang('waveportableairconditioner');
    let controller;

    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.mhFh5', //触发元素
            offset: 0.5, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 50, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const timelineA1 = new TimelineMax();
        const tweenA1 = TweenMax.to('.mhFh5 .img-box3', 0.5, {
            rotation: -90,
            ease: 'none',
        });
        const tweenA2 = TweenMax.fromTo(
            '.mhFh5 .img-box2',
            0.5,
            {
                y: -50,
                ease: 'none',
            },
            {
                y: 0,
                ease: 'none',
            },
        );
        const tweenA3 = TweenMax.fromTo(
            '.mhFh5 .img-box3',
            0.5,
            {
                y: -50,
                ease: 'none',
            },
            {
                y: 0,
                ease: 'none',
            },
        );
        timelineA1.add(tweenA1).add(tweenA2, 0.5).add(tweenA3, 0.5);
        sceneA1.setTween(timelineA1);

        controller.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.mhFh5} mhFh5`}>
            <div className="ms-title">{t('mh200.mhF2_ms1')}</div>
            <div className="img-box-out">
                <div className="img-box img-box2">
                    <EFPic name={['product06_2.webp', 'product06_2.png']} className="fullImgs" />
                </div>
                <div className="img-box img-box3">
                    <EFPic name={['product06_3.webp', 'product06_3.png']} className="fullImgs" />
                </div>
                <div className="img-box img-box1">
                    <EFPic name={['product06.webp', 'product06.png']} className="fullImgs" />
                </div>
            </div>
            <div className="ms-box">
                <div className="ms-desc">{t('mh200.mhF2_ms2')}</div>
                <div className="ms-tip">{t('mh200.mhF2_ms3')}</div>
                <div className="ms-bottom">
                    <div className="left">
                        <p className="text1">
                            {t('mh200.mhF2_ms4')}
                            {t('mh200.mhF2_ms5')}
                        </p>
                        <p className="text2">{t('mh200.mhF2_ms6')}</p>
                    </div>
                    <div className="right">
                        <EFmhAcIcon3 width=".69rem" height=".69rem" />
                    </div>
                </div>
            </div>
        </div>
    );
}
